import { useLanguage } from '@/i18n/LanguageContext';
import { usePlaylist } from '@/hooks/usePlaylist';
import PlaylistCard from './PlaylistCard';
import { ListMusic } from 'lucide-react';

const PlaylistsSection = () => {
  const { t } = useLanguage();
  const { playlists, startPlaylist, activePlaylist } = usePlaylist();

  return (
    <div>
      <h2 className="text-xs uppercase tracking-widest text-muted-foreground/40 mb-4 flex items-center gap-2">
        <span className="w-1 h-1 rounded-full bg-muted-foreground/20" />
        <ListMusic className="w-3 h-3" />
        {t('room_playlists') || 'Room Playlists'}
      </h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {playlists.map(playlist => (
          <PlaylistCard
            key={playlist.id}
            playlist={playlist}
            onStart={startPlaylist}
            isActive={activePlaylist?.playlistId === playlist.id}
          />
        ))}
      </div>
    </div>
  );
};

export default PlaylistsSection;
